import * as React from "react";

import BaseCalendarView, {
  type BaseCalendarViewProps,
  type CalendarWithOptionalHeaderViewProps,
  type SingleSelectionCalendarViewProps,
} from "./BaseCalendarView";
import Calendar from "./Calendar";
import Body from "./CalendarBody/Body";
import Header, { type HeaderProps } from "./CalendarHeader/Header";

const HOUR_CALENDAR_ROW_WIDTH = 4;

type HourViewProps = BaseCalendarViewProps &
  SingleSelectionCalendarViewProps &
  CalendarWithOptionalHeaderViewProps;

class HourView extends BaseCalendarView<HourViewProps, any> {
  public render() {
    const {
      values,
      hasHeader,
      onValueClick,
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasPrevPage,
      hasNextPage,
      onHeaderClick,
      disabledItemIndexes,
      activeItemIndex,
      currentHeadingValue,
      hoveredItemIndex,
      onCellHover,
      onMount,
      inline,
      localization,
      ...rest
    } = this.props;
    const headerProps = {
      className: "suicr-hour-view-header",
      onNextPageBtnClick,
      onPrevPageBtnClick,
      hasPrevPage,
      hasNextPage,
      onHeaderClick,
      title: currentHeadingValue,
      width: HOUR_CALENDAR_ROW_WIDTH,
      displayWeeks: false,
      localization,
    } as HeaderProps;

    return (
      <Calendar
        ref={(e) => {
          this.calendarNode = e as any;
        }}
        outlineOnFocus={inline}
        {...(rest as any)}
      >
        {hasHeader && <Header {...headerProps} />}
        <Body
          data={values}
          width={HOUR_CALENDAR_ROW_WIDTH}
          onCellClick={onValueClick}
          hovered={hoveredItemIndex}
          onCellHover={onCellHover}
          active={activeItemIndex}
          disabled={disabledItemIndexes}
        />
      </Calendar>
    );
  }
}

export default HourView;
